<template>
  <div style="width: 595px; position: relative; margin-left: auto; margin-right: auto;">
    <head>
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap"
        rel="stylesheet">
    </head>
    <component :is="currentComponent" :campaignData="campaignData" />
  </div>
</template>

<script>
import AgentExtendPdfV2 from './AgentExtendPdfV2.vue';
import PropertyPdfV2 from './PropertyPdfV2.vue';
import CampaignService from '../../../services/campaigns';

export default {
  name: 'CampaignNewPdfReports',
  components: {
    AgentExtendPdfV2,
    PropertyPdfV2
  },
  data() {
    return {
      campaignData: null,
    };
  },
  computed: {
    currentComponent() {
      console.log('Campaign:', this.campaignData);
      if (this.campaignData) {
        const component = this.campaignData.type.includes('property') || this.campaignData.type.includes('agent extend') || this.campaignData.type.includes('office')
          ? 'PropertyPdfV2' 
          : 'AgentExtendPdfV2';
        return component;
      }
      return null;
    }
  },
  methods: {
    fetchCampaign() {
      if (this.$route.params.campaignId) {
        CampaignService.getCampaignPublic(this.$route.params.campaignId, this.$route.params.token).then(result => {
          this.campaignData = result;
          console.log('Fetched Campaign:', this.campaignData);
        }).catch(error => {
          console.error('Error fetching campaign:', error);
        });
      }
    }
  },
  mounted() {
    this.fetchCampaign();
  }
};
</script>

<style>
  .container {
    position: relative;
    width: 595px;
    max-width: 100%;
    min-height: 100vh; /* Ensure the container takes the full height of the viewport */
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
  }

</style>